import { React, useEffect, useState, useRef, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';
import "./index.scss";

import ProfileAvatar from '../../../ui/ProfileAvatar';
// import CheckBox from "../../../ui/CheckBox";
import Button from "../../../ui/Button";
import Pagination from "../../../ui/Pagination";
import NoDataFound from "../../../ui/NoDataFound";
import SideModal from "../../../ui/SideModal";
import DropDown from "../../../ui/DropDown";
import RadioButton from "../../../ui/RadioButton";

import ModifyOrganization from "../ModifyOrganization";

import { editIcon, filterIcon, filterCloseIcon, searchIcon } from "../../../../utils/icons";
import { formatDate, getOrganizationImageUrl, getUserImageUrl } from "../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { getOrganizationByUser, resetOrganizationListByUser } from '../../../../store/actions/usersAction';
import { resetAssignUnassignResponse } from "../../../../store/actions/organizationActions";
import SkeletonLoader from "../../../ui/SkeletonLoader";

const businessImpactOption = [
    {
        label: "Critical",
        value: "critical"
    },
    {
        label: "High",
        value: "high"
    },
    {
        label: "Medium",
        value: "medium"
    },
    {
        label: "Low",
        value: "low"
    }
]

const sortByOption = [
    {
        label: "Internal",
        value: "internal"
    },
    {
        label: "Portfolio",
        value: "portfolio"
    },
    {
        label: "Third Party",
        value: "third_part"
    }
]

const filterRadioOption = [    
    {
        label: "Ascending",
        value: "asc"
    },
    {
        label: "Descending",
        value: "desc"
    }
]


const OrganizationTab = ({customerDetails="", userDetails="", currentPageType="usersDetails"}) => {

    const organizationListByUserResponse = useSelector((state) => state?.users?.organizationListByUserResponse);
    const assignUnAssignResponse = useSelector((state) => state.organization?.assignUnAssignResponse)

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const filterWrapperRef = useRef(null);
    //search value
    const [orgSearchValue, setOrgSearchValue] = useState("");
    const [orgSearchedValue, setOrgSearchedValue] = useState("");
    const [isOrgSearchFocused, setIsOrgSearchFocused] = useState(false);
    //filter values
    const [selectedBusinessImpact, setSelectedBusinessImpact] = useState("");
    const [selectedSortby, setSelectedSortby] = useState("");
    const [selectedSortOrder, setSelectedSortOrder] = useState("");
    //selected filter value
    const [filterSelectedBusinessImpact, setFilterSelectedBusinessImpact] = useState("");
    const [filterSelectedSortby, setFilterSelectedSortby] = useState("");
    const [filterSelectedSortOrder, setFilterSelectedSortOrder] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [showFilter, setShowFilter] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // const [selectedValue, setSelectedValue] = useState([]);
    const [showModifySidePanel, setShowModifySidePanel] = useState(false);

    const [organizationList, setOrganizationList] = useState(null);

    const removeFilter = (type) => {
        setCurrentPage(1);
        if(type === "businessImpact") {
            setSelectedBusinessImpact("")
            setFilterSelectedBusinessImpact("")
        } else if (type === "sortorder") {
            setSelectedSortOrder("");
            setFilterSelectedSortOrder("")
        } else if (type === "sortby") {
            setSelectedSortby("");
            setSelectedSortOrder("");
            setFilterSelectedSortby("");
            setFilterSelectedSortOrder("");
        }
    }

    const applyFilter = () => {
        setCurrentPage(1);
        setFilterSelectedBusinessImpact(selectedBusinessImpact)
        setFilterSelectedSortby(selectedSortby)
        setFilterSelectedSortOrder(selectedSortOrder)
        setShowFilter(false)        
    }

    const displaySortByName = (type) => {
        if (type === "businessImpact") {
            const matchedOption = businessImpactOption.find((data) => data.value === selectedBusinessImpact)
            return matchedOption ? matchedOption.label : "";
        } else if (type === "sortOrder") {
            const matchedOption = filterRadioOption.find((data) => data.value === selectedSortOrder)
            return matchedOption ? matchedOption.label : "";
        } else {
            const matchedOption = sortByOption.find((data) => data.value === selectedSortby)
            return matchedOption ? matchedOption.label : "";
        }
    }

    const filterClicked = () => {
        setShowFilter(true)
    }

    const sortOrderChange = (data) => {
        setSelectedSortOrder(data)
    }

    const closeModifyModal = () => {
        setShowModifySidePanel(false)
    }

    const closeModifyOrgsModal = () => {
        if(assignUnAssignResponse?.detail?.status === "success") {
            setIsLoading(true)
            fetchOrganizationList()
        }
        dispatch(resetAssignUnassignResponse());
        closeModifyModal()
    }

    // const isChecked = (data) => {
    //     if(selectedValue.length > 0 ){
    //         return selectedValue.some(item => item.organization_id === data.organization_id);
    //     }
    //     return false
    // }

    // const changeSelectAll = (e) => {
    //     if(e.target.checked) {
    //         setSelectedValue(organizationList?.results)
    //     } else {
    //         setSelectedValue([])
    //     }
    // }

    // const setCheckboxvalue = (e) => {
    //     if(e.target.checked) {
    //         let checkedValue = organizationList?.results.filter(item => item.organization_id === e.target.value);
    //         setSelectedValue([...selectedValue, ...checkedValue])
    //     } else {
    //         const updatedList = selectedValue.filter(item => item.organization_id !== e.target.value);
    //         setSelectedValue(updatedList);
    //     }
    // }

    const organizationSecondaryText = (data) => {
        let date = formatDate(data.created_at)
        return `${data.type} | ${date}`
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isOrgSearchFocused) {
            searchOrganization()
        }
    }

    const searchOrganization = () => {
        setCurrentPage(1);
        setOrgSearchedValue(orgSearchValue)
    }

    const fetchOrganizationList = useCallback(()=>{
        if(currentPageType === "usersDetails") {
            const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&user_id=${userDetails?.user_id}`;
            const queryParams = orgSearchedValue ? `&query=${orgSearchedValue}` : "";
            const sortParams = (filterSelectedBusinessImpact ? `&business_impact=${filterSelectedBusinessImpact}` : '') + (filterSelectedSortby ? `&sort_by=${filterSelectedSortby}` : '') + (filterSelectedSortOrder ? `&sort_order=${filterSelectedSortOrder}` : '');
            const url = `${baseUrl}${queryParams}${sortParams}`; 
            if(userDetails?.user_id) {
                dispatch(getOrganizationByUser(url, "list"))
            }            
        } else {
            const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&customer_id=${customerDetails?.customer_id}`;
            const queryParams = orgSearchedValue ? `&query=${orgSearchedValue}` : "";
            const sortParams = (filterSelectedBusinessImpact ? `&business_impact=${filterSelectedBusinessImpact}` : '') + (filterSelectedSortby ? `&sort_by=${filterSelectedSortby}` : '') + (filterSelectedSortOrder ? `&sort_order=${filterSelectedSortOrder}` : '');
            const url = `${baseUrl}${queryParams}${sortParams}`;
            if(customerDetails?.customer_id) {
                dispatch(getOrganizationByUser(url, "list"))
            }            
        }
        
    },[dispatch, currentPage, currentPageSize, customerDetails, userDetails, currentPageType, orgSearchedValue, filterSelectedBusinessImpact, filterSelectedSortby, filterSelectedSortOrder])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }        
        }
    },[showFilter])
    

    useEffect(()=>{
        setIsLoading(true)
        fetchOrganizationList()
    },[fetchOrganizationList])

    useEffect(()=>{
        if(organizationListByUserResponse !== null) {
            setOrganizationList(organizationListByUserResponse)
            setIsLoading(false)
            dispatch(resetOrganizationListByUser())
        }
    },[organizationListByUserResponse, dispatch])

    return (
        <Row>
            <Col md={12}>
                <div className="search-filter-container my-3 d-flex justify-content-between align-items-center">
                    <div className="search-container d-flex align-items-center gap-3">
                        <div className="position-relative" onKeyDown={handleSearchKeyDown}>
                            <input className="search-input rounded" 
                                placeholder="Search organization" 
                                value={orgSearchValue} 
                                onChange={(e)=>setOrgSearchValue(e.target.value)}
                                onFocus={() => setIsOrgSearchFocused(true)}
                                onBlur={() => setIsOrgSearchFocused(false)}
                            />
                            <span className="position-absolute search-icon">{searchIcon()}</span>
                        </div>
                        <button className="search-btn" onClick={()=>{searchOrganization()}}>Search</button>
                        <div className="position-relative">
                            <span className="filter-icon" onClick={filterClicked}>{filterIcon()}</span>
                            {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>                                
                                <h6>Business Impact</h6>
                                    <DropDown 
                                        placeHolder={"Business Impact"}
                                        options={businessImpactOption}
                                        isMulti={false}
                                        isSearchable={false}
                                        onChange={(data)=>{setSelectedBusinessImpact(data.value)}}
                                        defaultSelectedValue={selectedBusinessImpact}
                                    />
                                <h6 className="mt-4">Sort By</h6>
                                    <DropDown 
                                        placeHolder={"Sort By"}
                                        options={sortByOption}
                                        isMulti={false}
                                        isSearchable={false}
                                        onChange={(data)=>{setSelectedSortby(data.value)}}
                                        defaultSelectedValue={selectedSortby}
                                    />
                                <h6 className="mt-4">Sort Order</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        filterRadioOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={sortOrderChange} key={index} isChecked={data.value === selectedSortOrder} />
                                            )
                                        })
                                    }
                                </div>
                                <div className="filter-apply-btn mt-3">
                                    <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={false} buttonClicked={()=>{applyFilter()}}/>
                                </div>
                            </div>}
                        </div>
                        {!showFilter && <p className="selected-filters">
                            {filterSelectedBusinessImpact !== "" && <span className="d-inline-block mx-2">{displaySortByName("businessImpact")} <span onClick={() => removeFilter("businessImpact")}>{filterCloseIcon()}</span></span>}
                            {filterSelectedSortby !== "" && <span className="d-inline-block mx-2">{displaySortByName("sortby")} <span onClick={() => removeFilter("sortby")}>{filterCloseIcon()}</span></span>}
                            {filterSelectedSortOrder !== "" && <span className="d-inline-block mx-2">{displaySortByName("sortOrder")} <span onClick={() => removeFilter("sortorder")}>{filterCloseIcon()}</span></span>}
                        </p>}
                    </div>
                    <div className="sort-edit-container">
                        <div className="container d-flex gap-3 align-items-center">                            
                            {currentPageType === "usersDetails" && <button className="edit-btn" onClick={()=>{                                                               
                                    setShowModifySidePanel(true)
                                }}>
                                <p className="d-inline-block mx-1">{editIcon()}</p>
                                {t("organizationDetailsPage.modifyBtn")}
                            </button>}
                        </div>
                    </div>
                </div>
                <div className="domain-table-container user-page-org-table">
                    {
                        isLoading ?
                            <SkeletonLoader type={"line"} count={5} currentPage={"organizationTab"} />
                            :
                            <Table responsive="lg">
                                <thead>
                                    <tr>
                                        {/* <th className="org-tabel-select-all"><CheckBox checkBoxId={2} checkBoxValue={"select all"} handleCheckboxChange={changeSelectAll}/></th> */}
                                        <th>{t("userDetailsPage.detailPageOrganizationTab.organizationDetails")}</th>
                                        <th>{t("userDetailsPage.detailPageOrganizationTab.createdBy")}</th>
                                        <th>{t("userDetailsPage.detailPageOrganizationTab.score")}</th>
                                        <th>{t("userDetailsPage.detailPageOrganizationTab.businessImpact")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        organizationList?.results?.length > 0 && 
                                        organizationList?.results.map((data, index)=>{
                                            return (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                >
                                                    {/* <td>
                                                        <CheckBox checkBoxId={index} checkBoxValue={data.organization_id} handleCheckboxChange={setCheckboxvalue} isChecked={isChecked(data)} />
                                                    </td> */}
                                                    <td>
                                                        <ProfileAvatar type="profile" firstName={data.name} secondaryText={organizationSecondaryText(data)} imageUrl={getOrganizationImageUrl(data)} />
                                                    </td>
                                                    <td>
                                                        <ProfileAvatar type="profile" firstName={data?.created_by?.name} lastName={" "} secondaryText={`${data?.created_by?.role} | ${data?.created_by?.user_type || ""}`} imageUrl={getUserImageUrl(data?.created_by)} />
                                                    </td>
                                                    <td>
                                                        {data?.stats?.overall_score?.obtained_score}
                                                    </td>
                                                    <td>
                                                        {data?.business_impact === "critical" && <p className="business-impact critical">Critical</p>}
                                                        {data?.business_impact === "high" && <p className="business-impact high">High</p>}
                                                        {data?.business_impact === "medium" && <p className="business-impact medium">Medium</p>}
                                                        {data?.business_impact === "low" && <p className="business-impact low">Low</p>}
                                                    </td>
                                                </motion.tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                    }
                    {
                    !isLoading && organizationList?.results?.length === 0 &&
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <NoDataFound noDataText={"No data Found"}/>
                        </motion.div>
                    }
                    {organizationList !== null && !isLoading && organizationList?.meta?.total_results !== 0 && <Pagination
                        className="pagination-bar"
                        currentPage={currentPage}
                        pageSize={currentPageSize}
                        totalCount={organizationList?.meta?.total_results ? organizationList?.meta.total_results : 0}
                        onPageChange={setCurrentPageandRecordSize}
                    />}
                    <SideModal showSidePanel={showModifySidePanel} hideSidePanel={closeModifyOrgsModal}>
                        {showModifySidePanel && <ModifyOrganization closeModifyOrgsModal={closeModifyOrgsModal} userDetails={userDetails} customerDetails={customerDetails} currentPageType={currentPageType}/>}
                    </SideModal>
                </div>
            </Col>
        </Row>
    )
}

export default OrganizationTab;